// BasicDetails.js
import { useState } from "react";
import DetailsComponent from "@/components/ui/cards/DetailsComponent";
import ToolTip from "@/components/ui/tooltip/ToolTip";

import styles from "@/components/ev-details/BasicDetails.module.css";

const BasicDetails = ({ data }) => {
  const [showAdvanced, setShowAdvanced] = useState(false); // internal state for showing advanced data

  const handleToggle = (newState) => {
    setShowAdvanced(newState);
  };

  const sortedData = data.sort((a, b) => a.cw_position - b.cw_position);

  return (
    <DetailsComponent title="Basics" showToggle={true} onToggle={handleToggle}>
      <div className={styles.detailBox}>
        {sortedData.map((detail, index) => {
          // If the detail is advanced and showAdvanced is false, return null
          if (detail.advanced && !showAdvanced) {
            return null;
          }

          // Render each detail
          return (
            <div key={index} className={styles.detail}>
              <div className={styles.detailData}>
                <span className={styles.detailValue}>{detail.value}</span>
                <span className={styles.detailUnit}>
                  {detail.unit ? ` ${detail.unit}` : ""}
                </span>
              </div>
              <div className={styles.detailLabel}>{detail.label}</div>
              {detail.description && (
                <ToolTip tooltipText={detail.description}>
                  <span>?</span>
                </ToolTip>
              )}
            </div>
          );
        })}
      </div>
    </DetailsComponent>
  );
};

export default BasicDetails;
